import { Card as CardBase } from "antd";
import styled from "styled-components";

export const Card = styled(CardBase)`
  margin: 24px 0;
  .ant-card-head {
    padding: 0;
    margin: 0 24px;
  }
  .ant-card-body {
    padding: 24px 24px 0 24px;
  }
  .ant-card-actions {
    border-top: none;
  }
`;
